// extracted by mini-css-extract-plugin
export default {"cls1":"ConfirmationBanner-cls1_mBe","cls2":"ConfirmationBanner-cls2_QqO ConfirmationBanner-cls1_mBe"};